import { render, staticRenderFns } from "./PayoutLimitEditor.vue?vue&type=template&id=9855c98e&"
import script from "./PayoutLimitEditor.vue?vue&type=script&lang=js&"
export * from "./PayoutLimitEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports